<template>
    <div class="wrapper">
        <h1>{{ $t('labels.enter_amount') }}</h1>

        <input name="amount" id="amount" class="form-control form-control--large" v-model="value" disabled>

        <div class="row">
            <div class="col-md-4">
                <cancel-button :redirect="cancelRedirect()"></cancel-button>
            </div>
        </div>
    </div>
</template>

<script>
    import CancelButton from "../components/app/CancelButton";
    import { writeTrackLog } from "../utils/tracking";

    export default {
        name: 'amount',

        components: {CancelButton},

        data () {
            return {
                value: ''
            }
        },

        computed: {
            currentDevice () {
                return this.$store.getters.currentDevice;
            },

            currentEmployee () {
                return this.$store.getters.currentEmployee;
            },

            currentActivity () {
                return this.$store.getters.currentActivityForEmployee;
            }
        },

        methods: {
            cancelRedirect () {
				if (this.currentActivity) {
                    const activity = this.$store.getters.activityById(this.currentActivity.activity_id);

                    if (this.currentDevice.pre_register_activities) {
						if (activity.register_row_status) return {name: 'row-status'};
            if (activity.register_row_percentage) return {name: 'row-percentage'};
						if (activity.register_row_numbers) return {name: 'row'};
						if (activity.register_package_types) return {name: 'packaging'};
						if (activity.register_team_numbers) return {name: 'team'};
                    } else {
						if (activity.register_package_types) return {name: 'packaging'};
						if (activity.register_team_numbers) return {name: 'team'};
                    }
                }

                return {name: 'activity'};
            }
        },

        mounted () {
			if (this.$store.state.enableTracking) writeTrackLog("VIEW: Amount");
            if (this.currentEmployee === null || this.currentEmployee === undefined) return this.$router.push('pin');

			if (this.currentActivity !== null && this.currentActivity !== undefined && this.currentActivity.amount !== null) {
                this.value = this.currentActivity.amount;
            }

            window.events.$emit('enableNumpad');

            window.events.$on('numpadType', value => {
                if (document.getElementById('amount')) this.value = this.value + value;
            });

            window.events.$on('backspace', () => {
                if (document.getElementById('amount')) this.value = '';
            });

            window.events.$on('submitFromNumpad', () => {
                if (process.env.NODE_ENV === 'development') console.log('Amount submit', this.currentActivity, this);

                const field = document.getElementById('amount');

                if (field === null || field === undefined || this.value === '') return;

                const oldEntry = this.currentActivity;

                const timesheetEntry = {
                    id: this.currentActivity.id,
                    amount: parseInt(this.value, 10),
                };

				if (this.$store.state.enableTracking) writeTrackLog("Set amount: " + JSON.stringify(timesheetEntry));

                oldEntry.amount = timesheetEntry.amount;

                // this.$store.commit('syncOnline', true);
                this.$store.dispatch('updateActivity', timesheetEntry);

                const route = this.$parent.determineRoute(oldEntry);

                if (route !== null && route !== undefined) return this.$router.push(route);

                return this.$router.push('activity');
            });
        },

        beforeDestroy () {
            window.events.$off('submitFromNumpad');
            window.events.$off('backspace');
            window.events.$off('numpadType');
        }
    }
</script>


